module.exports = __webpack_public_path__ + "img/homeimg04@2x_wps.379a639b.png";